import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { ComponentValues, Components } from '../../components';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-content-group',
  standalone: true,
  imports: [CommonModule, StoryblokDirective, DynamicComponent, DynamicIoDirective, BlockWrapperComponent],
  templateUrl: './content-group.component.html',
  styleUrls: ['./content-group.component.scss'],
})
export class ContentGroupComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() blocks: InstanceType<ComponentValues>[];
  @Input() alignBlocks: string;

  components = Components;

  ngOnChanges() {
    this.style[0] = this.style[0] || <BlockStyle>{};
    this.style[0].alignLeftChildPages = this.alignBlocks === 'left';

    this.blocks.forEach(item => {
      if (!('style' in item)) return;
      if (!item.style) return;
      if (Array.isArray(item.style) && !item.style.length) {
        item.style = [{} as BlockStyle];
      }
      item.style[0].inWrapper = true;
    });
  }

  trackByFunction(index: number, item: InstanceType<ComponentValues>) {
    return item._uid;
  }
}
